import api from './api';

/**
 * Category service for managing inventory categories
 */

export const categoryService = {
  /**
   * Get all categories, optionally filtered by search
   */
  getAll: async (skip = 0, limit = 100, search = null) => {
    const params = { skip, limit };
    if (search) {
      params.search = search;
    }
    const response = await api.get('/categories', { params });
    return response.data;
  },

  /**
   * Get a single category by ID
   */
  getById: async (categoryId) => {
    const response = await api.get(`/categories/${categoryId}`);
    return response.data;
  },

  /**
   * Create a new category
   */
  create: async (categoryData) => {
    const response = await api.post('/categories', categoryData);
    return response.data;
  },

  /**
   * Update an existing category
   */
  update: async (categoryId, categoryData) => {
    const response = await api.put(`/categories/${categoryId}`, categoryData);
    return response.data;
  },

  /**
   * Delete a category
   */
  delete: async (categoryId) => {
    await api.delete(`/categories/${categoryId}`);
  }
};
